var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMir(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 57.143,
    height: 16,
    viewBox: "0 0 57.143 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#006848;}.b{fill:url(#a);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -61.501,
    y1: 77.878,
    x2: -61.484,
    y2: 77.878,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e5cd8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02afff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M208.165-36.657l-2.122,7.35h-.363l-2.121-7.35a2.918,2.918,0,0,0-2.8-2.1h-5.089v16h5.1v-9.456h.363l2.917,9.456h3.642l2.911-9.456h.363v9.456h5.094v-16h-5.088A2.915,2.915,0,0,0,208.165-36.657Zm28.208,13.9H241.5v-4.731h5.158a6.284,6.284,0,0,0,5.883-3.669H236.373ZM227.292-37.07,223.706-29.3h-.363v-9.456h-5.1v16h4.325a2.919,2.919,0,0,0,2.647-1.688l3.587-7.762h.363v9.45h5.094v-16h-4.325A2.919,2.919,0,0,0,227.292-37.07Z",
    transform: "translate(-195.666 38.757)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M247.164-38.757a5.605,5.605,0,0,1,3.811,1.487,5.582,5.582,0,0,1,1.834,4.144,5.742,5.742,0,0,1-.094.994h-9.463a7.165,7.165,0,0,1-6.835-5c-.012-.031-.018-.069-.031-.106-.025-.088-.044-.182-.069-.269a7.412,7.412,0,0,1-.181-1.25Z",
    transform: "translate(-195.666 38.757)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMir);
export default __webpack_public_path__ + "static/media/mir.e1a3cf22b1692e39f1fd0682f0b794a4.svg";
export { ForwardRef as ReactComponent };